exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".confirmation__dialog__paper {\n  max-width: 350px !important;\n  padding-bottom: 30px !important; }\n\n.confirmation__dialog__yesNo__button__row {\n  margin: 4px auto !important;\n  flex-direction: row-reverse; }\n\n.confirmation__dialog__yesNo__title__text {\n  font-family: 'Geomanist';\n  font-size: 25px;\n  font-weight: 400;\n  line-height: 25px;\n  letter-spacing: -0.4px;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Utility/Dialogs/index.scss
// module id = 1063
// module chunks = 1